import React, { useEffect, useState } from "react";
import { localStoreName } from "../../utils/constants";

export const StopTimer = () => {
  const [date, setDate] = useState({
    d: "00",
    h: "00",
    m: "00",
    s: "00",
  });

  useEffect(() => {
    let timer = setInterval(() => {
      let end = JSON.parse(localStorage.getItem(localStoreName))?.technical_test
        ?.ended_at;
      var countDownDate = new Date(end).getTime();
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, Secutes and seconds
      let d = Math.floor(distance / (1000 * 60 * 60 * 24));
      let h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let s = Math.floor((distance % (1000 * 60)) / 1000);

      setDate({ d, h, m, s });
    }, 1000);

    if (Number(date.s) < 0) {
      clearInterval(timer);
    }

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div
      className="darkBlueBG rounded-pill px-5 py-3"
      style={{
        background: Number(date.d) <= 0 && Number(date.h) < 7 ? "#E0523F" : "",
        position: "fixed",
        top: "1rem",
        left: "50%",
        zIndex: 80,
        transform: "translateX(-50%)",
      }}
    >
      {Number(date.s) < 0 ? (
        <h3 className="mb-0">Time is Up</h3>
      ) : (
        <div className="d-flex align-items-center">
          <div className="d-flex flex-column align-items-center">
            <span className="h4 mb-0 font-weight-bold">{date.d}</span>
            <span className="mutedText">Days</span>
          </div>
          <span className="h2 font-weight-bold px-2 mb-0">:</span>

          <div className="d-flex flex-column align-items-center">
            <span className="h4 mb-0 font-weight-bold">{date.h}</span>
            <span className="mutedText">Hrs</span>
          </div>
          <span className="h2 font-weight-bold px-2 mb-0">:</span>

          <div className="d-flex flex-column align-items-center">
            <span className="h4 mb-0 font-weight-bold">{date.m}</span>
            <span className="mutedText">Min</span>
          </div>
          <span className="h2 font-weight-bold px-2 mb-0">:</span>

          <div className="d-flex flex-column align-items-center">
            <span className="h4 mb-0 font-weight-bold">{date.s}</span>
            <span className="mutedText">Sec</span>
          </div>
        </div>
      )}
    </div>
  );
};
